import bg2 from '../../images/bg-2.jpg'
import { qcls, qfonts } from './quizTheme'

interface Props {
  onRestart: () => void
}

export default function ThankYouPage({ onRestart }: Props) {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundImage: `url(${bg2})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      {/* ── Hero ── */}
      <div className="flex flex-1 flex-col items-center justify-center px-6 py-10 text-center relative">
        <div className="flex flex-col items-center">
          {/* Check circle */}
          <div className="w-24 h-24 rounded-full flex items-center justify-center mb-14" style={{ border: '4px solid #1ac987' }}>
            <svg className="w-12 h-12 text-[#1ac987]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <p className="text-black text-[24px] font-quiz-heading mb-5">
            Assessment complete
          </p>
          <h1 className={`text-[32px] font-black text-black leading-tight mb-8 ${qfonts.heading}`}>
            You're all done!
          </h1>
          <div className="max-w-lg w-full mb-16">
            <p
              className="text-black leading-relaxed text-left"
              style={{ fontFamily: 'RobotoMono, Arial, sans-serif', fontSize: 16 }}
            >
              Thank you for completing the assessment. Your responses have been recorded and your competence profile is being calculated.
            </p>
            <p
              className="text-black leading-relaxed text-left mt-4"
              style={{ fontFamily: 'RobotoMono, Arial, sans-serif', fontSize: 16 }}
            >
              A personalised report will be prepared based on your answers.
            </p>
          </div>

          <div className="flex justify-center mt-4">
          <button
            onClick={onRestart}
            className="px-8 py-4 border bg-black hover:brightness-95 active:scale-[0.99] transition-all"
            style={{ color: '#ffffff', borderColor: '#000000', fontFamily: 'RobotoMono, Arial, sans-serif', fontSize: 16, fontWeight: 700 }}
          >
            Start a new session
          </button>
        </div>
        </div>
      </div>

      {/* ── Footer ── */}
      <div className="w-full pb-8 flex justify-center">
        <p className="text-xs text-black text-center">
          &copy; {new Date().getFullYear()} UNSW. All rights reserved.
        </p>
      </div>
    </div>
  )
}
